export default __webpack_public_path__ + "5bbb226fc0582dd2615372371a03421f.gif";